import {
    getChartDataActiveUsers,
    getChartDataUsage,
    getHeapMapData,
    getPastSixMonthsData
} from "./misc/utils";
import { object, string } from "yup";
import { useEffect, useState } from "react";

import size from "lodash/size";
import useAxios from "@src/utility/hooks/use-axios";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import useSearchParams from "@src/utility/hooks/use-search-params";
import { yupResolver } from "@hookform/resolvers/yup";

const useUsage = (props) => {
    const { platformId } = useParams();
    const { attributes } = props;
    const [heatMapData, setHeatMapData] = useState([]);
    const [activeUserData, setActiveUserData] = useState({});
    const [usageData, setUsageData] = useState({});

    const { getSearchParams, createSearchParams } = useSearchParams();

    const methods = useForm({
        defaultValues: {
            event: ""
        },
        resolver: yupResolver(
            object({
                event: string()
            })
        )
    });

    const start = getSearchParams("start");
    const end = getSearchParams("end");

    const [segments, setSegments] = useState([]);

    const { axiosInstance, loading } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const clientID = attributes?.cid;

    const getFrequency = async (eventsParam) => {
        const response = await axiosInstance.get(`/events/${platformId}/frequency`, {
            params: {
                org_id: [clientID].join(","),
                start,
                end,
                events: eventsParam
            }
        });
        const dataLastMonthsFormatted = getPastSixMonthsData();
        const heatMapData =
            getHeapMapData({
                pastSixMonthsData: dataLastMonthsFormatted,
                data             : response.data.data
            }) || [];
        setHeatMapData(heatMapData);
    };

    const getUsage = async (eventsParam) => {
        const response = await axiosInstance.get(`/events/${platformId}/reports`, {
            params: {
                org_id: [clientID].join(","),
                start,
                end,
                events: eventsParam
            }
        });
        const data = getChartDataUsage({
            data      : response.data.data,
            start_date: response.data.start_date,
            end_date  : response.data.end_date,
            events_map: response.data.events_map,
            metrics   : response.data.filters.event
        });
        setUsageData(data);
    };

    const getActiveUsers = async (eventsParam) => {
        const response = await axiosInstance.get(`/events/${platformId}/active-users`, {
            params: {
                org_id: [clientID].join(","),
                start,
                end,
                events: eventsParam

            }
        });
        const METRICS_MAP = {
            unique_users: "Unique Users",
            total_events: "Total Events"
        };
        const data = getChartDataActiveUsers({
            data      : response.data.data,
            start_date: response.data.start_date,
            end_date  : response.data.end_date,
            events_map: METRICS_MAP,
            metrics   : Object.keys(METRICS_MAP)
        });
        setActiveUserData(data);
    };

    const getSegments = async () => {
        const response = await axiosInstance.get(
            `/segments/${platformId}/check-client/${attributes._id}`
        );
        if (response.data) {
            setSegments(response.data);
        }
    };

    const onSubmit = (overrideEvent) => {
        const effectiveEvent = overrideEvent || getSearchParams("event");
        getFrequency(effectiveEvent);
        getUsage(effectiveEvent);
        getActiveUsers(effectiveEvent);
    };
 
    const handleEventSelect = (option) => {
        const selectedEvent = option?.value || "";
        createSearchParams("event", selectedEvent);
        getFrequency(selectedEvent);
        getUsage(selectedEvent);
        getActiveUsers(selectedEvent);
        getSegments();
    };

    useEffect(() => {
        if (size(attributes) && start && end) {
            onSubmit();
            getSegments();
        }
    }, [attributes, start, end]);

    return {
        loading,
        segments,
        onSubmit,
        methods,
        usageData,
        getActiveUsers,
        handleEventSelect,
        activeUserData,
        heatMapData
    };
};

export default useUsage;